import { BorderRadius, Color, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const AccountSyncStatusWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${Spacing.S6};
  width: fit-content;
  max-width: 100%;
  padding: ${Spacing.S6};
  border-radius: ${BorderRadius.R16};
  background-color: ${Color.Grey50};
  white-space: nowrap;
`

export const RenewButtonWrapper = styled.div`
  width: fit-content;
  max-width: 100%;
`
